import React from 'react';
import BrandArrow from '../ui/BrandArrow';
import ctaPhoto from '../../assets/WEB_SOLE_FOTO_COSTILLA_GROUP-05-web.webp';
import './CtaBanner.css';

const WHATSAPP_SOLE = '5493816818108';

const MENSAJE_ASESOR =
  'Hola SC Group! Me gustaría que me asesoren para mi próximo evento. ' +
  '¿Me cuentan disponibilidad y opciones?';

const WHATSAPP_URL = `https://wa.me/${WHATSAPP_SOLE}?text=${encodeURIComponent(
  MENSAJE_ASESOR
)}`;

export default function CtaBanner() {
  return (
    <section
      id="cta-banner"
      className="cta-banner"
      aria-label="Comienza aquí — foto de la fundadora de Sole Costilla Group"
    >
      <div className="cta-banner__inner">
        <h2 className="cta-banner__title">
          <span>Nuestro trabajo creativo</span>
          <span><p>comienza aquí</p> y vamos por todo</span><span>lo que sigue</span>
        </h2>
        <a
          className="cta-banner__btn"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Que me asesoren</span>
          <span className="cta-banner__btn-arrow" aria-hidden="true">
            <BrandArrow />
          </span>
        </a>
      </div>
      <img
        className="cta-banner__photo"
        src={ctaPhoto}
        alt=""
        aria-hidden="true"
        decoding="async"
        draggable={false}
      />
    </section>
  );
}
